import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;

export const getAdminToken = () => localStorage.getItem('admin_token');
export const setAdminToken = (t) => localStorage.setItem('admin_token', t);
export const clearAdminToken = () => localStorage.removeItem('admin_token');

export const adminAxios = () => axios.create({
  baseURL: ADMIN_API,
  headers: { Authorization: `Bearer ${getAdminToken()}` },
});

// Colors
export const C = {
  navy: '#1E3A63', navy2: '#2B4C7E', gold: '#C9A24B', cream: '#F7F1E8',
  green: '#7FA98C', red: '#C0492E', ink: '#2C3A47', mute: '#8D8880', line: '#E8EAEE',
};

export const fmtMoney = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—');
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(' ');
  return e?.message || 'Something went wrong';
}
